export var setCookieValue = function setCookieValue(_ref) {
  var key = _ref.key,
      value = _ref.value,
      maxAge = _ref.maxAge;
  document.cookie = key + '=' + value + '; max-age=' + maxAge + ';domain=.onepeloton.com; path=/;';
};